module.exports = __webpack_public_path__ + "static/media/teamlead.92d82da1.jpg";